import { TableSortIconWrapper } from './TableSortIconWrapper';

// TODO: in v9, move styled() from TableSortIconWrapper.jsx to here
export var StyledTableSortIconWrapper = TableSortIconWrapper;